import React, { useEffect, useRef } from "react";

function AnimatedCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let animationFrameId;
    let time = 0;

    const resizeCanvas = () => {
      const parent = canvas.parentElement;

      if (parent) {
        canvas.width = parent.clientWidth;
        canvas.height = parent.clientHeight;
      }
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const waves = [
      {
        color: "rgba(59,130,246,0.10)",
        amplitude: 40,
        speed: 0.06,
        offset: 0,
      },
      {
        color: "rgba(255,255,255,0.20)",
        amplitude: 50,
        speed: 0.04,
        offset: 2,
      },
      {
        color: "rgba(147,197,253,0.10)",
        amplitude: 35,
        speed: 0.07,
        offset: 4,
      },
    ];

    const drawBackground = () => {
      const gradient = ctx.createLinearGradient(
        0,
        0,
        canvas.width,
        canvas.height
      );

      gradient.addColorStop(0, "#0F4C81");
      gradient.addColorStop(0.5, "#4F8FC9");
      gradient.addColorStop(1, "#B6E3FF");

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    const drawWave = (amplitude, color, speed, offset) => {
      ctx.beginPath();
      ctx.moveTo(0, 0);

      for (let y = 0; y <= canvas.height; y++) {
        const x =
          Math.sin(y * 0.004 + time * speed + offset) *
            amplitude +
          canvas.width * 0.25;

        ctx.lineTo(x, y);
      }

      ctx.lineTo(0, canvas.height);
      ctx.closePath();

      ctx.fillStyle = color;
      ctx.shadowBlur = 20;
      ctx.shadowColor = "rgba(255,255,255,0.1)";
      ctx.fill();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      drawBackground();

      waves.forEach((wave) => {
        drawWave(
          wave.amplitude,
          wave.color,
          wave.speed,
          wave.offset
        );
      });

      time += 1;

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
    />
  );
}

export default AnimatedCanvas;